/* eslint-disable no-irregular-whitespace */
import React, {memo, useCallback, useState} from "react";
import styles from "./ChannelMainCard.module.css";
import {useNavigate} from "react-router-dom";
import PuiTooltip from "../../../components/elements/PuiTooltip ";
import PuiTypography from "../../../components/elements/PuiTypography";
import {Video} from "../../../stores/program/model/Program";
import CaptionIcon from "../images/CaptionIcon";
import ViewCountIcon from "../images/ViewCountIcon";
import HorizonNewIcon from "../images/HorizonNewIcon";
import SlideButton from "../images/SlideButton";
import SlideButtonFocus from "../images/SlideButtonFocus";
import {format} from "date-fns";

interface ChannelMainCardProps {
  video: Video;
}

function ChannelMainCard({video}: ChannelMainCardProps) {
    const navigate = useNavigate();
    const goToVideo = useCallback(
        () => navigate(`/video/${video.hash}`),
        [navigate, video.hash]
    );

    const [isSlideButtonFocus, setIsSlideButtonFocus] = useState<boolean>(false);

    return (
        <div
            key={`ChannelMainCard-${video.id}`}
            className={styles.card}
            onClick={goToVideo}
        >
            <div className={styles.thumbnaildiv}>
                <img
                    className={styles.thumbnail}
                    src={video.imageUrl}
                    alt={video.title}
                />
            </div>

            <div className={styles.info}>
                <div className={styles.titleRow}>
                    <div className={styles.titleRowLeft}>
                        {video.visibleNewIcon && (
                            <div className={styles.newIcon}>
                                <HorizonNewIcon/>
                            </div>
                        )}
                        {video.publicCaption && (
                            <div className={styles.captionIcon}>
                                <CaptionIcon/>
                            </div>
                        )}
                        <div
                            className={styles.cardTitle}
                            data-for="listtitle"
                            data-tip={video.title}
                        >
                            <PuiTypography size={16} bold={true} color={"white"}>
                                {video.title}
                            </PuiTypography>
                        </div>
                        <PuiTooltip id="listtitle"/>
                    </div>
                    {video.SlideFlg && (
                        <div
                            className={styles.slideIcon}
                            onMouseEnter={() => setIsSlideButtonFocus(true)}
                            onMouseLeave={() => setIsSlideButtonFocus(false)}
                        >
                            {!isSlideButtonFocus && <SlideButton/>}
                            {isSlideButtonFocus && <SlideButtonFocus/>}
                        </div>
                    )}
                </div>
                <div className={styles.metaRow}>
                    <div
                        className={styles.cardPresenter}
                        data-for="listpresenter"
                        data-tip={video.presenter}
                    >
                        <PuiTypography size={14} color={"white"}>
                            {video.presenter}
                        </PuiTypography>
                    </div>
                    <PuiTooltip id="listpresenter"/>

                    <div className={styles.meta}>
                        <div className={styles.viewCount}>
                            <ViewCountIcon/>
                        </div>
                        <PuiTypography size={14} color={"white"}>
                            {`${video.viewCount}回視聴　・　${
                                video.updated
                                    ? format(
                                        Date.parse(String(video.updated).split("T")[0]),
                                        "yyyy年MM月dd日"
                                    )
                                    : "不明"
                            }`}
                        </PuiTypography>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default memo(ChannelMainCard);
